import { api, ApiRequestConfig } from './api';
import type { ProductRedirection, ProductRedirectionRequest } from '../types/product-url';

export const getProductRedirectUrl = (props: ProductRedirectionRequest, config: ApiRequestConfig) =>
  api.get<ProductRedirection>('get-product-url', { ...props }, config);
